module.exports = __webpack_public_path__ + "img/5.177add08.png";